"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAngularParser = void 0;
var parse_1 = __importDefault(require("angular-expressions/lib/parse"));
var get_1 = __importDefault(require("lodash/get"));
var applyToBracketedExpressions_1 = __importDefault(require("./render/util/applyToBracketedExpressions"));
var angular_parser_utils_1 = require("./angular-parser-utils");
var filters = {};
var Lexer = parse_1.default.Lexer;
var Parser = parse_1.default.Parser;
var parserOptions = {
    csp: true,
    expensiveChecks: true,
    literals: {
        // defined at: function $ParseProvider() {
        true: true,
        false: false,
        null: null,
        /*eslint no-undefined: 0*/
        undefined: undefined,
        /* eslint: no-undefined: 1  */
    },
    //isIdentifierStart: undefined, //isFunction(identStart) && identStart,
    //isIdentifierContinue: undefined //isFunction(identContinue) && identContinue
};
var lexer = new Lexer({});
var parser = new Parser(lexer, function getFilter(name) {
    return filters[name];
}, parserOptions);
/**
 * Compiles src and returns a function that executes src on a target object.
 * The compiled function is cached under compile.cache[src] to speed up further calls.
 *
 * @param {string} src
 * @returns {function}
 */
function compile(src) {
    var cached;
    if (typeof src !== 'string') {
        throw new TypeError("src must be a string, instead saw '" + typeof src + "'");
    }
    if (!compile.cache) {
        return parser.parse(src);
    }
    cached = compile.cache[src];
    if (!cached) {
        cached = compile.cache[src] = parser.parse(src);
    }
    return cached;
}
/**
 * A cache containing all compiled functions. The src is used as key.
 * Set this on false to disable the cache.
 *
 * @type {object}
 */
compile.cache = {};
function numberWithCommas(x) {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}
filters.toFixed = function (input, digits) {
    // https://github.com/open-xml-templating/docxtemplater/issues/480#issuecomment-554651251
    // This condition should be used to make sure that if your input is undefined, your output will be undefined as well and will not throw an error
    if (!input && input !== 0)
        return input;
    return numberWithCommas(input.toFixed(digits));
};
filters.orderBy = angular_parser_utils_1.orderByNullsFirst;
filters.orderByNullsFirst = angular_parser_utils_1.orderByNullsFirst;
filters.orderByNullsLast = angular_parser_utils_1.orderByNullsLast;
// for joining strings with commas, for example.
filters.joinBy = function (input, delimiter) {
    return (input || []).join(delimiter || ', ');
};
filters.withIndexes = function (input) {
    if (Array.isArray(input) && input.length > 0 && input.findIndex(function (e) { return !e || (e && typeof e !== 'object'); }) === -1) {
        return input.map(function (e, i) {
            return __assign(__assign({}, e), { $index: i, $isLast: i === input.length - 1 });
        });
    }
    return input;
};
filters.upper = function (input) { return (!input ? input : input.toUpperCase()); };
// For image stuff
filters.size = function (input, width, height) {
    return {
        data: input,
        sizePixel: [width, height],
    };
};
filters.maxSize = function (input, width, height) {
    return {
        data: input,
        maxSize: [width, height],
    };
};
var isSpelTag = function (tag) {
    return tag.startsWith('$') && tag.endsWith('$');
};
var convertDocxTicks = function (tag) {
    return tag
        .split('’')
        .join("'")
        .split('‘')
        .join("'")
        .split('“')
        .join('"')
        .split('”')
        .join('"');
};
var evalTag = function (tag) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        /*
            We can't attach indexes to primitives, so we can't do this when our scope is a number or an object.
        */
        var r = compile(convertDocxTicks(tag)).apply(void 0, args);
        if (Array.isArray(r)) {
            r.forEach(function (el, index) {
                if (el && typeof el === 'object') {
                    el.$index = index;
                    el.$last = index === r.length - 1;
                }
            });
        }
        return r;
    };
};
function getAngularParser(mode, evaluator) {
    var spelCollected = [];
    var angularParser = function (tag) {
        var get = tag === '.'
            ? function (s) { return s; }
            : tag === '$length'
                ? function (scope, context) {
                    return context.scopePathLength[context.scopePathLength.length - 1];
                }
                : tag === '$index'
                    ? function (scope, context) {
                        var indexes = context.scopePathItem;
                        return indexes[indexes.length - 1];
                    }
                    : tag === '$last'
                        ? function (scope, context) {
                            var length = context.scopePathLength[context.scopePathLength.length - 1];
                            var index = context.scopePathItem[context.scopePathItem.length - 1];
                            return index === length - 1;
                        }
                        : isSpelTag(tag) && mode === 'ESCAPE_SPEL'
                            ? // here we need to eval any unescaped brackets and reconstruct the string
                                (function () {
                                    var input = tag.slice(1, tag.length - 2);
                                    return function (scope, context) {
                                        var getSpel = function (_a, stringifyStrings) {
                                            var openingBracket = _a[0], closingBracket = _a[1];
                                            if (stringifyStrings === void 0) { stringifyStrings = false; }
                                            return function (_input) {
                                                return (0, applyToBracketedExpressions_1.default)(function (_tag) {
                                                    var result = undefined;
                                                    // we handle scope traversal ourselves here, by iterating upwards
                                                    // through the scopelist until we are out of possible scopes
                                                    // or we have a result.
                                                    // this allows <<foundInScopeN-1>> <<foundInScopeN>>
                                                    // as part of the same {$ ... $} tag.
                                                    var __tag = _tag.trim();
                                                    var getResult = function (i) {
                                                        switch (__tag) {
                                                            case '.':
                                                                return scope;
                                                            case '$length':
                                                                return (context.scopePathLength &&
                                                                    context.scopePathLength[context.scopePathLength.length - 1]);
                                                            case '$index': {
                                                                var indexes = context.scopePathItem;
                                                                return indexes && indexes[indexes.length - 1];
                                                            }
                                                            default: {
                                                                return (0, get_1.default)(context.scopeList[i], __tag);
                                                            }
                                                        }
                                                    };
                                                    var i = context.scopeList.length - 1;
                                                    while (i > 0 && typeof getResult(i) === 'undefined') {
                                                        i--;
                                                    }
                                                    result = getResult(i);
                                                    if (stringifyStrings) {
                                                        if (typeof result === 'undefined' || result === null) {
                                                            return 'null';
                                                        }
                                                        if (typeof result === 'string') {
                                                            // escape quotes, SPEL style:
                                                            return '"' + result.replaceAll('"', '""') + '"';
                                                        }
                                                    }
                                                    if (typeof result === 'undefined') {
                                                        return '';
                                                    }
                                                    return result;
                                                }, openingBracket, closingBracket)(_input);
                                            };
                                        };
                                        var templated1 = getSpel(['<<', '>>'])(input);
                                        var spel = getSpel(['<[', ']>'], true)(templated1);
                                        var res = '{$' + spel + '$}';
                                        spelCollected.push(convertDocxTicks(spel));
                                        return res;
                                    };
                                })()
                            : isSpelTag(tag) && mode === 'EVAL_SPEL'
                                ? function () {
                                    return evaluator(convertDocxTicks(tag.slice(1, -1)));
                                }
                                : mode === 'ESCAPE_SPEL'
                                    ? function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        // we need to escape curly brackets, since the renderer will take another pass and interpret those as template tag opener/closers
                                        var r = evalTag(tag).apply(void 0, args);
                                        if (r && typeof r === 'string') {
                                            return r
                                                .split('{')
                                                .map(function (s) { return s.split('}').join('{$ CLOSE_CURLY_BRACKET $}'); })
                                                .join('{$ OPEN_CURLY_BRACKET $}');
                                        }
                                        return r;
                                    }
                                    : evalTag(tag);
        return {
            get: get,
        };
    };
    return {
        parser: angularParser,
        getSpelCollectedByParser: function () {
            return spelCollected;
        },
    };
}
exports.getAngularParser = getAngularParser;
exports.default = getAngularParser('ESCAPE_SPEL').parser;
//# sourceMappingURL=angular-parser.js.map